
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/template",
      function () {
        return require("private-next-pages/template/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/template"])
      });
    }
  